import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);
  const { setAuthedUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;
    if (!session_id) {
      setError("Missing session_id in URL");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id });
        setAuthedUser({
          id: data.user_id,
          email: data.email,
          name: data.name,
          picture: data.picture,
          auth_provider: "google",
        });
        // Clear the hash + go to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        nav("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        setError(e.response?.data?.detail || "Google sign-in failed");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/30" data-testid="auth-callback">
      <div className="p-8 bg-card rounded-lg shadow-md text-center max-w-md">
        {!error ? (
          <>
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[hsl(24.6_95%_53.1%)] mx-auto mb-4"></div>
            <div className="font-display text-lg font-semibold">Signing you in…</div>
            <div className="text-sm text-muted-foreground mt-1">Finishing Google authentication</div>
          </>
        ) : (
          <>
            <div className="text-destructive font-semibold mb-2">Sign-in failed</div>
            <div className="text-sm text-muted-foreground mb-4">{error}</div>
            <button onClick={() => nav("/login")} className="text-sm text-[hsl(24.6_95%_53.1%)] underline">Back to Login</button>
          </>
        )}
      </div>
    </div>
  );
}
